import React from "react";
import "./ButtonPrimary.css";
import { Link } from "react-router-dom";

function ButtonPrimary(props) {
  return (
    <Link className="button-primary" to={props.to} onClick={props.onClick}>
      {props.tittle}
    </Link>
  );
}

export default ButtonPrimary;
